import React from 'react';
import './photo.css';

const Photo = ({ src, alt }) => {
  return <img className="gallery-photo" src={src} alt={alt} />;
};

export default Photo;